(function (global) {
  'use strict';

  // Kameraknappen sitter i skallet og kan trykkes fra hvilken som helst side.
  // Dialogen den aapner ligger i rutepakkene, som lastes ved behov — derfor maa
  // ruten vaere lastet for dialogen kan vises.
  //
  // Sjekken gjelder alt dialogen faktisk bruker, ikke bare dialogen selv:
  // kontovelgeren kommer fra en annen fil i den samme rutepakka. Var bare
  // dialogen sjekket, ville en manglende avhengighet blitt en tom skjerm i det
  // brukeren trykket paa kameraet — verst paa mobil, der kameraet er hovedveien
  // inn for et bilag.
  function dialogReady() {
    return Boolean(global.ReceiptSinglePaymentSourceDialog && global.InvoicePayAccountSelect);
  }

  async function preparePaymentDialog(target) {
    if (dialogReady()) return { ready: true };
    if (!global.PlummePageLoader?.loadRoute) return { ready: false };
    try {
      await global.PlummePageLoader.loadRoute(target);
      return { ready: dialogReady() };
    } catch (error) {
      return { ready: false, error: error };
    }
  }

  global.PlummeCameraCaptureRoute = Object.freeze({ preparePaymentDialog: preparePaymentDialog });
})(window);
